import { mapDTO } from '@twistezo/ts-dto-mapper'

import { floatPercentToDTO } from 'utils/number'
import { Schema } from '../../schema'
import { Variables } from './types'

type From = Schema
type Props = {
  from: From
  withControllingRefreshParamsOnAdUnitLevel?: boolean
}
type To = Variables

export const toDTO = ({ from, withControllingRefreshParamsOnAdUnitLevel }: Props): To =>
  mapDTO<From, To>({ from }).transform((from: From): To => {
    const { id, refresherEnabled } = from

    let flaggedBasicSettings = {}
    if (withControllingRefreshParamsOnAdUnitLevel) {
      const {
        customizeRefresherBasicSettingsEnabled,
        desktopAdThreshold,
        desktopMonitorUserScrollEnabled,
        desktopRefreshInterval,
        mobileAdThreshold,
        mobileMonitorUserScrollEnabled,
        mobileRefreshInterval,
      } = from.basicSettings as NonNullable<From['basicSettings']>

      flaggedBasicSettings = {
        customizeRefresherBasicSettingsEnabled,
        desktopAdThreshold: floatPercentToDTO(desktopAdThreshold),
        desktopMonitorUserScrollEnabled,
        desktopRefreshInterval: desktopRefreshInterval * 1000,
        mobileAdThreshold: floatPercentToDTO(mobileAdThreshold),
        mobileMonitorUserScrollEnabled,
        mobileRefreshInterval: mobileRefreshInterval * 1000,
      }
    }

    return {
      adUnitId: id,
      refresherEnabled,
      ...(withControllingRefreshParamsOnAdUnitLevel ? flaggedBasicSettings : {}),
    }
  })
